/* eslint-disable no-console */
import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const EDIT_TEXT_INPUT = 'EDIT_TEXT_INPUT';

export const GET_GEOGRAPHIES_ERROR = 'GET_GEOGRAPHIES_ERROR';
export const GET_GEOGRAPHIES_INIT = 'GET_GEOGRAPHIES_INIT';
export const GET_GEOGRAPHIES_SUCCESS = 'GET_GEOGRAPHIES_SUCCESS';

export const GET_INDUSTRIES_ERROR = 'GET_INDUSTRIES_ERROR';
export const GET_INDUSTRIES_INIT = 'GET_INDUSTRIES_INIT';
export const GET_INDUSTRIES_SUCCESS = 'GET_INDUSTRIES_SUCCESS';

export const GET_MARKETPLACE_MATCHES_ERROR = 'GET_MARKETPLACE_MATCHES_ERROR';
export const GET_MARKETPLACE_MATCHES_START = 'GET_MARKETPLACE_MATCHES_START';
export const GET_MARKETPLACE_MATCHES_SUCCESS = 'GET_MARKETPLACE_MATCHES_SUCCESS';

export const GET_PREFERENCES_ERROR = 'GET_PREFERENCES_ERROR';
export const GET_PREFERENCES_INIT = 'GET_PREFERENCES_INIT';
export const GET_PREFERENCES_SUCCESS = 'GET_PREFERENCES_SUCCESS';

export const SAVE_PREFERENCES_ERROR = 'SAVE_PREFERENCES_ERROR';
export const SAVE_PREFERENCES_INIT = 'SAVE_PREFERENCES_INIT';
export const SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';

export const TOGGLE_INPUT = 'TOGGLE_INPUT';
export const TOGGLE_ITEM = 'TOGGLE_ITEM';

export const GET_SURVEY_DETAILS_START = 'GET_SURVEY_DETAILS_START';
export const GET_SURVEY_DETAILS_SUCCESS = 'GET_SURVEY_DETAILS_SUCCESS';
export const GET_SURVEY_DETAILS_ERROR = 'GET_SURVEY_DETAILS_ERROR';

export const RESET_MARKETPLACE_MATCHES = 'RESET_MARKETPLACE_MATCHES';
export const TOGGLE_ONLY_SHOW_FREQUENT = 'TOGGLE_ONLY_SHOW_FREQUENT';

export const PURCHASE_SUBMIT_START = 'PURCHASE_SUBMIT_START';
export const PURCHASE_SUBMIT_SUCCESS = 'PURCHASE_SUBMIT_SUCCESS';
export const PURCHASE_SUBMIT_ERROR = 'PURCHASE_SUBMIT_ERROR';
export const PURCHASE_SUBMIT_RESET = 'PURCHASE_SUBMIT_RESET';

export const SET_SELECTED_SLIDEOUT_JOBS = 'SET_SELECTED_SLIDEOUT_JOBS';
export const CLEAR_SELECTED_SLIDEOUT_JOBS = 'CLEAR_SELECTED_SLIDEOUT_JOBS';
export const CHANGE_SLIDEOUT_JOB = 'CHANGE_SLIDEOUT_JOB';
export const TOGGLE_ACTIVE_SURVEYS = 'TOGGLE_ACTIVE_SURVEYS';
export const SET_VISIBLE_SURVEYS_COUNT = 'SET_VISIBLE_SURVEYS_COUNT';
export const SET_SLIDEOUT_SEARCH_TEXT = 'SET_SLIDEOUT_SEARCH_TEXT';
export const SET_JOB_STATUS = 'SET_JOB_STATUS';

export const setSlideoutJobs = ({ selectedJobIds, startingJobIndex, jobs }) => {
  jobs.sort((a, b) => selectedJobIds.indexOf(a.jobId) - selectedJobIds.indexOf(b.jobId));
  return { type: SET_SELECTED_SLIDEOUT_JOBS, selectedJobIds, jobs, startingJobIndex };
};

export const clearSlideoutJobs = () => ({ type: CLEAR_SELECTED_SLIDEOUT_JOBS });
export const changeSlideoutJob = payload => ({ type: CHANGE_SLIDEOUT_JOB, nextOrPrevious: payload });
export const toggleActiveSurveys = payload => ({ type: TOGGLE_ACTIVE_SURVEYS, active: payload });
export const setSearchText = payload => ({ type: SET_SLIDEOUT_SEARCH_TEXT, payload });
export const setJobStatus = payload => ({ type: SET_JOB_STATUS, payload });

export function editTextInput(field, event) {
  const dataType = field === 'min-employee__input' ? 'minEmployee' : 'minCompany';
  return { type: EDIT_TEXT_INPUT, data: { dataType, event } };
}

export const setVisibleSurveysCount = payload => ({ type: SET_VISIBLE_SURVEYS_COUNT, payload });

export function getGeographies() {
  return async dispatch => {
    try {
      dispatch({ type: GET_GEOGRAPHIES_INIT });

      const result = await apiClient.apiGet('/api/recommender/marketplace-matches/getGeographies', {});
      dispatch({ type: GET_GEOGRAPHIES_SUCCESS, data: result.data.data });
    } catch (error) {
      dispatch({ type: GET_GEOGRAPHIES_ERROR, error });
    }
  };
}

export function getIndustries() {
  return async dispatch => {
    try {
      dispatch({ type: GET_INDUSTRIES_INIT });

      const result = await apiClient.apiGet('/api/recommender/marketplace-matches/getIndustries', {});
      dispatch({ type: GET_INDUSTRIES_SUCCESS, data: result.data.data });
    } catch (error) {
      dispatch({ type: GET_INDUSTRIES_ERROR, error });
    }
  };
}

export function toggleFrequent(value) {
  return async dispatch => {
    dispatch({ type: TOGGLE_ONLY_SHOW_FREQUENT, value });
  };
}

/*
  Get a list of survey jobs that are recommended by the DS recommender, based on current job matches
*/
export function getMarketplaceMatches(currentSurveyJobs, currency, purchased, isNew) {
  return async dispatch => {
    const errorMessage = 'Error retrieving marketplace matches';

    try {
      dispatch({ type: GET_MARKETPLACE_MATCHES_START, purchased });

      if (!currentSurveyJobs || currentSurveyJobs.length === 0) {
        dispatch({
          type: GET_MARKETPLACE_MATCHES_ERROR,
          status: 404,
          message: 'No current survey job matches for this job'
        });
      }

      if (currentSurveyJobs?.length > 0) {
        const result = await apiClient.apiPost('/api/recommender/marketplace-matches/search', {
          currentMatches: currentSurveyJobs,
          currency,
          purchased
        });

        if (result.data.status < 300) {
          const recs = result.data?.recommendations?.length ? result.data.recommendations : null;
          dispatch({
            type: GET_MARKETPLACE_MATCHES_SUCCESS,
            status: result.data.status,
            isNew,
            purchased,
            purchasedData: purchased ? recs : null,
            unpurchasedData: purchased ? null : recs
          });
        } else {
          dispatch({
            type: GET_MARKETPLACE_MATCHES_ERROR,
            status: result.data.status,
            message: result.data.reason
          });

          throw Error(errorMessage);
        }
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch error in getMarketplaceMatches: ', error);
      dispatch({ type: GET_MARKETPLACE_MATCHES_ERROR });
    }
  };
}

export function resetMarketplaceMatches() {
  return { type: RESET_MARKETPLACE_MATCHES };
}

export function getPreferences() {
  return async dispatch => {
    try {
      dispatch({ type: GET_PREFERENCES_INIT });

      const response = await apiClient.apiGet('/api/recommender/marketplace-matches/getPreferences');
      dispatch({ type: GET_PREFERENCES_SUCCESS, data: response.data });
    } catch (error) {
      dispatch({ type: GET_PREFERENCES_ERROR, error });
    }
  };
}

export function multiSelectChange(field, input) {
  return { type: TOGGLE_ITEM, field, input };
}

export function savePreferences(preferences, apply = false) {
  return async dispatch => {
    try {
      dispatch({ type: SAVE_PREFERENCES_INIT });

      const response = await apiClient.apiPost('/api/recommender/marketplace-matches/setPreferences', preferences);
      dispatch({ type: SAVE_PREFERENCES_SUCCESS, settings: apply ? preferences : null });
    } catch (error) {
      dispatch({ type: SAVE_PREFERENCES_ERROR, error });
    }
  };
}

export function getSurveyDetails(rowData, surveyJobs, filteredSurveyJobs, type) {
  return async dispatch => {
    dispatch({ type: GET_SURVEY_DETAILS_START, surveyJobs, filteredSurveyJobs });

    if (!rowData) {
      dispatch({ type: GET_SURVEY_DETAILS_ERROR, error: 'Could not get survey details', currentJob: null });
    } else {
      let currentIndex;
      let newIndex;
      let cutIdIndex;

      for (let i = 0; i < filteredSurveyJobs.length; i++) {
        const cutId =
          rowData.field_cutId || rowData.cutId || rowData.field_cut_id || rowData.cut_id_default || rowData.cut_id;
        if (filteredSurveyJobs[i]?.includes(cutId)) {
          currentIndex = i;
          cutIdIndex = filteredSurveyJobs[i]?.indexOf(cutId);
        }
      }

      if (type === 'previous') {
        if (currentIndex === 0) {
          newIndex = filteredSurveyJobs.length - 1;
        } else {
          newIndex = currentIndex - 1;
        }
      } else if (type === 'next') {
        if (currentIndex === filteredSurveyJobs.length - 1) {
          newIndex = 0;
        } else {
          newIndex = currentIndex + 1;
        }
      } else {
        newIndex = currentIndex;
      }

      if (cutIdIndex === undefined || newIndex === undefined) {
        dispatch({ type: GET_SURVEY_DETAILS_ERROR, error: 'Could not get survey details', currentJob: null });
      } else {
        const newCutId = filteredSurveyJobs[newIndex][cutIdIndex];
        const deets = surveyJobs.find(j => j.cutId === newCutId);

        const params = {
          cutId: deets.cutId,
          pubSurveyCode: deets.pubSurveyCode
        };

        try {
          const response = await apiClient.apiGet('/api/market-pricing/surveys/getExtendedSurveyJobDetails', {
            params
          });
          const details = response.data.details;
          details.confidence = deets.confidence;
          details.pubSurveyCode = deets.pubSurveyCode;
          if (!details.job_title) details.job_title = deets.jobTitle;

          dispatch({ type: GET_SURVEY_DETAILS_SUCCESS, data: response.data, currentJob: deets });
        } catch (error) {
          dispatch({ type: GET_SURVEY_DETAILS_ERROR, error, currentJob: deets });
        }
      }
    }
  };
}

export function purchaseSubmit(
  priceFormatted,
  participationPriceFormatted,
  pubSurveyCode,
  pubSurveyTitle,
  participation
) {
  return async dispatch => {
    const errorMessage = 'Error submitting purchase request';

    try {
      dispatch({ type: PURCHASE_SUBMIT_START });

      await apiClient.apiPost('/api/market-pricing/surveys/purchaseSubmit', {
        priceFormatted,
        participationPriceFormatted,
        pubSurveyCode,
        pubSurveyTitle,
        participation
      });

      dispatch({ type: PURCHASE_SUBMIT_SUCCESS });
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch error in purchaseSubmit: ', error);
      dispatch({ type: PURCHASE_SUBMIT_ERROR });
    }
  };
}

export function resetPurchaseSubmit() {
  return { type: PURCHASE_SUBMIT_RESET };
}
